var $ = require('jquery');
var _ = require('underscore');
var DialogWarning = require('DialogWarning');
var Entities = require('Entities');

module.exports.run = function(options) {
    var record = options.record;
    var subtypeId = record.get('subtypeId');
    var subtype = record.get('subtype');
    var subjectId = record.get('subjectId');
    var subject = record.get('subject');
    var deferred = $.Deferred();
    var promise = deferred.promise();

    if (subjectId && subtypeId) {
        return new Entities.Classifications().fetch({
            aggregate: [
                { $match: { $or: [{ _id: subtypeId, text: subtype }, { _id: subjectId, text: subject }] } },
                { $count: 'count' }
            ]
        }).done(function (response) {
            if (!response.length || (response.length && _.first(response).count < 2)) {
                record.set({ subtypeId: '', subtype: '', subjectId: '', subject: '' });
                DialogWarning.show({
                    message: EY.Consultation.Labels.ClassificationWarning
                });

            }
            deferred.resolve();
        });
    } else {
        deferred.resolve();
    }
    return promise;
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/ClassificationValidation.js